"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateId = generateId;
exports.getRandomInRange = getRandomInRange;
exports.randomFlag = randomFlag;
exports.debounce = debounce;
exports.rad2deg = rad2deg;
exports.deg2rad = deg2rad;
function generateId() {
    return "".concat(Math.random().toString(36).slice(2));
}
function getRandomInRange(min, max, plusminus) {
    if (plusminus === void 0) { plusminus = false; }
    if (min === max)
        return min;
    var result = Math.round(min - 0.5 + (Math.random() * (max - min + 1)));
    if (plusminus)
        return Math.random() > 0.5 ? result : -result;
    return result;
}
function randomFlag() {
    var random = getRandomInRange(1, 100);
    return random >= 50;
}
function debounce(fn, delay) {
    var timeoutId;
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function () { return fn.apply(_this, args); }, delay);
    };
}
function rad2deg(rad) {
    var rad2deg_k = 180 / Math.PI;
    return rad * rad2deg_k;
}
function deg2rad(deg) {
    var deg2rad_k = Math.PI / 180;
    return deg * deg2rad_k;
}
